import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
    return (
        <section className="hero">
            <div className="hero-bg"></div>
            <div className="container">
                <div className="hero-content">
                    <h1 className="hero-title">
                        Solutions IT Innovantes
                        <span className="gradient-text"> Pour Votre Succès</span>
                    </h1>
                    <p className="hero-subtitle">
                        Transformez votre entreprise avec notre expertise en développement, Intelligence Artificielle et Cloud.
                    </p>
                    <div className="hero-buttons">
                        <Link to="/contact" className="btn btn-primary">
                            Commencer Maintenant
                        </Link>
                        <Link to="/services" className="btn btn-secondary">
                            Découvrir nos services
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}